// extracted by css-extract-rspack-plugin
export default {"Box":"InfobarPopover-module__Box__KDoFn","CircleOcticon":"InfobarPopover-module__CircleOcticon__rzFFE","success":"InfobarPopover-module__success__JEzuA"};